import notfound from '../assets/notfound.jpg'
import { useNavigate } from "react-router-dom";
import { Button, Col, Image, Row, Typography } from "antd";

const { Title } = Typography

function ErrorPage(): JSX.Element {
  const navigate = useNavigate()

  return (
    <Row id="not-found" style={{ height: "100%" }}>
      <Col xs={24} sm={24} md={12} lg={12}>
        <Image
          height="100%"
          preview={false}
          src={notfound}
          style={{ objectFit: 'cover' }}
        />
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} style={{ height: "100%", backgroundColor: "#4976ba", textAlign: 'center' }} span={12}>
        <div style={{ position: 'absolute', top: "50%", transform: "translateY(-50%)", padding: 15 }}>
          <Typography style={{ color: "#fff" }}>AXA ERROR</Typography>
          <Title level={3} style={{ color: "#fff" }}>Page was not found</Title>
          <Typography style={{ color: "#fff", marginBottom: 10 }}>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Mollitia veritatis, quisquam illo eos iure atque alias laborum, repudiandae laboriosam eveniet quas. Iusto blanditiis quas culpa! Accusamus odit debitis adipisci omnis?</Typography>
          <Button onClick={() => navigate('/app/welcome')}>Page d'accueil</Button>
        </div>
      </Col>
    </Row>
  );
}

export default ErrorPage;
